// extracted by mini-css-extract-plugin
export default {"container":"WarehouseReturns_container__YYqPA"};